const Toggle = ({ checked, onChange }) => (
    <label
      style={{
        display: 'inline-flex',
        alignItems: 'center',
        cursor: 'pointer',
      }}
    >
      <input
        type="checkbox"
        style={{ display: 'none' }} // sr-only equivalent
        checked={checked}
        onChange={(e) => onChange(e.target.checked)}
      />
      <div
        style={{
          width: '50px', // Increased width to 50px
          height: '30px', // Increased height to 30px
          backgroundColor: checked ? '#4CAF50' : '#e0e0e0', // Green when checked, gray when not
          borderRadius: '9999px', // rounded-full equivalent
          position: 'relative',
          transition: 'background-color 0.3s ease', // Smooth color transition
        }}
      >
        <div
          style={{
            width: '22px', // Ball width (22px)
            height: '22px', // Ball height (22px)
            backgroundColor: 'white', // Ball color
            borderRadius: '50%', // rounded-full equivalent
            boxShadow: '0 2px 4px rgba(0, 0, 0, 0.1)', // shadow equivalent
            transform: checked ? 'translateX(20px)' : 'translateX(0)', // Move ball to the right when checked
            transition: 'transform 0.3s ease', // Smooth transition for ball movement
            position: 'absolute',
            top: '50%',
            left: checked ? '50%' : '0', // Move the ball left or right
            transform: checked ? 'translateX(0px) translateY(-50%)' : 'translateX(0) translateY(-50%)', // Center vertically
          }}
        ></div>
      </div>
    </label>
  );
  
  export default Toggle;
  